import type { AxiosInstance } from 'axios';
import { ISessionManagerProvider } from 'interfaces/providers/ISessionManagerProvider';
import { ISessionRosters } from 'interfaces/session/ISessionRosters';
import { IApiSessionMetadataUpdateRequest } from 'interfaces/tagging/ApiModels/IApiSessionMetadataUpdateRequest';
import { injectable } from 'inversify';
import { Result } from 'services/Result';

@injectable()
export class SessionManagerService implements ISessionManagerProvider {
  private axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  async updateSessionMetadata(sessionMetadata: IApiSessionMetadataUpdateRequest) {
    await this.axiosInstance.post<Result<string>>('api/session/updateSessionMetadata', sessionMetadata);
  }

  async submitSessionMetadata(sessionId: string) {
    const result = await this.axiosInstance.post<Result<string>>(`api/session/submitSessionMetadata/${sessionId}`);
    console.log(result);
    if (result.status !== 200) {
      throw Error(result.statusText);
    }
  }

  async submitSessionRoster(roster: ISessionRosters) {
    await this.axiosInstance.post('api/session/sessionRosters', roster);
  }

  async getSessionRoster(sessionId: string) {
    const response = await this.axiosInstance.get<Result<ISessionRosters>>(`api/session/sessionRosters/${sessionId}`);
    return response.data.data;
  }

  submitSession = async (sessionMetadata: IApiSessionMetadataUpdateRequest) => {
    const response = await this.axiosInstance.post<Result<ISessionRosters>>(`api/session/submitSession/`, sessionMetadata);

    if (response.status !== 200) {
      throw Error(response.statusText);
    }
  };
}
